export const ADD_ASSET = 'ADD_ASSET';
export const REMOVE_ASSET = 'REMOVE_ASSET';
export const EDIT_ASSET = 'EDIT_ASSET';
export const SET_ASSETS = 'SET_ASSETS';
export const RESET_ASSETS = 'RESET_ASSETS';

export function addAsset(value) {
  return {
    type: ADD_ASSET,
    value,
  };
}

export function removeAsset(assetId) {
  return {
    type: REMOVE_ASSET,
    assetId,
  };
}

export function editAsset(value) {
  return {
    type: EDIT_ASSET,
    value,
  };
}

export function setAssets(value) {
  return {
    type: SET_ASSETS,
    value,
  };
}

export function resetAssets() {
  return {
    type: RESET_ASSETS,
  };
}
